import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import HousecallProLogo from 'housecall-ui/dist/IconsAndImages/Logos/HousecallProLogo';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

const useStyles = makeStyles((theme: HCPTheme) => ({
  typography: {
    marginRight: `${theme.spacing(0.5)}px`,
  },
}));

export const PoweredBy = () => {
  const { typography } = useStyles();

  return (
    <Grid container justify="center">
      <Typography variant="caption" color="textPrimary" className={typography}>
        Powered by
      </Typography>
      <HousecallProLogo color="primary" width={90} height={13} />
    </Grid>
  );
};
